exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-scroll-horizontal {\n    overflow: auto;\n    white-space: nowrap;\n    width: 100%;\n    max-height: 36vw;\n}\n.horizontal-spacer {\n    display: inline-block;\n    width: 20vw;\n    color: white;\n}\n.scroll-item {\n    display: inline-block;\n    width: 60vw;\n    height: 34vw;\n    border-right: 3px solid black;\n    color: white;\n}\n.scroll-img {\n    height: 100%;\n    width: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.img-overlay {\n    position: relative;\n    top: -3rem;\n    padding: 0.5rem;\n    background-color: rgba(0,0,0,0.5)\n}\n", ""]);

// exports
